import React from "react";
import { Box, Skeleton } from "@mui/material";
import styles from "./RewardTierCard.module.scss";

const RewardTierCardSkeleton: React.FC = () => {
  return (
    <Box className={styles.cardContainer}>
      <Box className={styles.header} display="flex" justifyContent={"center"}>
        <Skeleton variant="text" width={100} height={36} />
      </Box>

      <Box padding="1rem 3rem">
        {[...Array(2)].map((_, index) => (
          <Box key={index} className={styles.tierItem}>
            <Box className={styles.tierBox}>
              <Box className={styles.tierRow}>
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  style={{ marginRight: 12 }}
                />
                <Box>
                  <Skeleton variant="text" width={180} height={24} />
                  <Skeleton variant="text" width={120} height={20} />
                </Box>
              </Box>

              <Skeleton
                variant="text"
                width={160}
                height={18}
                style={{ marginLeft: 30, marginTop: 8 }}
              />
              {index === 0 && (
                <Box className={styles.claimBox}>
                  <Box className={styles.iconWrapper}>
                    <Skeleton variant="circular" width={40} height={40} />
                  </Box>
                  <Box className={styles.claimTextContent}>
                    <Skeleton variant="text" width={180} height={20} />
                    <Skeleton variant="text" width={120} height={18} />
                    <Skeleton
                      variant="rectangular"
                      width={120}
                      height={36}
                      style={{ borderRadius: 8 }}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RewardTierCardSkeleton;
